import { css } from '@emotion/react';
// eslint-disable-next-line no-restricted-imports
import { Hyperlink, HyperlinkProps } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
import { WcpStyles } from '@workday/wcp-tokens';
import { Ref } from 'react';

const hyperlinkStyles = (props: HyperlinkProps) =>
  props?.variant === 'inverse'
    ? css({
        color: WcpStyles.color.text.inverse,
        '&:hover': {
          color: WcpStyles.color.text.inverse,
        },
        '&:focus': {
          boxShadow: `0 0 0 2px ${WcpStyles.color.border.inverse}`,
          outline: 'none',
        },
        '&:active': {
          color: WcpStyles.color.text.primary.strong,
          background: WcpStyles.color.bg.alt.soft,
        },
      })
    : css({
        color: WcpStyles.color.text.primary.default,
        '&:hover': {
          color: WcpStyles.color.text.primary.strong,
          background: WcpStyles.color.bg.alt.soft,
        },
        '&:focus': {
          boxShadow: `0 0 0 2px ${WcpStyles.color.border.primary}`,
          outline: 'none',
        },
        '&:active': {
          color: WcpStyles.color.text.primary.strong,
          background: WcpStyles.color.bg.alt.default,
        },
      });

export const ThemedHyperlink = createComponent('a')({
  Component: (props: HyperlinkProps, ref: Ref<HTMLAnchorElement>, Element) => (
    <Hyperlink ref={ref} as={Element} css={hyperlinkStyles(props)} {...props} />
  ),
});
